// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-bookmark-list {
  /* max-height: 200px; */
  width: 270px;
  margin-left: 13px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.book-bookmark-digest {
  font-size: 13px;
  line-height: 15px;
  opacity: 1;
  cursor: pointer;
}
.book-bookmark-index {
  float: left;
  width: 200px;
  height: 16px;
  font-size: 13px;
  opacity: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: keep-all;
  overflow: hidden;
  position: relative;
  top: 5px;
}
.book-bookmark-progress {
  width: 30px;
  height: 18px;
  margin-left: 12px;
  /* margin-top: 8px; */
  font-size: 13px;
  opacity: 1;
  float: right;
  line-height: 15px;
}
.book-bookmark-link {
  float: left;
  width: 63px;
  height: 26px;
  opacity: 1;
  border-radius: 13px;
  font-size: 11px;
  line-height: 24px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  position: relative;
  left: 10px;
  bottom: 5px;
}
.bookmark-page-list-item-title {
  width: calc(100% - 50px);
  overflow: hidden;
  height: 18px;
  margin-top: -3px;
  text-overflow: ellipsis;
  float: left;
  margin-left: 5px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/containers/lists/navList/navList.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".book-bookmark-list {\n  /* max-height: 200px; */\n  width: 270px;\n  margin-left: 13px;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n}\n.book-bookmark-digest {\n  font-size: 13px;\n  line-height: 15px;\n  opacity: 1;\n  cursor: pointer;\n}\n.book-bookmark-index {\n  float: left;\n  width: 200px;\n  height: 16px;\n  font-size: 13px;\n  opacity: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  white-space: normal;\n  word-break: keep-all;\n  overflow: hidden;\n  position: relative;\n  top: 5px;\n}\n.book-bookmark-progress {\n  width: 30px;\n  height: 18px;\n  margin-left: 12px;\n  /* margin-top: 8px; */\n  font-size: 13px;\n  opacity: 1;\n  float: right;\n  line-height: 15px;\n}\n.book-bookmark-link {\n  float: left;\n  width: 63px;\n  height: 26px;\n  opacity: 1;\n  border-radius: 13px;\n  font-size: 11px;\n  line-height: 24px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n  left: 10px;\n  bottom: 5px;\n}\n.bookmark-page-list-item-title {\n  width: calc(100% - 50px);\n  overflow: hidden;\n  height: 18px;\n  margin-top: -3px;\n  text-overflow: ellipsis;\n  float: left;\n  margin-left: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
